import { Colors } from '../consts/Colors';

export default class Breadcrumb extends Phaser.GameObjects.Container {
    constructor(scene, x, y, totalSteps, currentStep = 0) {
        super(scene, x, y);
        scene.add.existing(this);

        this.totalSteps = totalSteps;
        this.currentStep = currentStep;
        this.dots = [];

        this.createDots();
    }

    createDots() {
        const dotSpacing = 30; // Espacement entre les points
        const dotSize = 10; // Taille des points
        const activeColor = Colors.Elmt.Red;
        const inactiveColor = Colors.Elmt.White;

        for (let i = 0; i < this.totalSteps; i++) {
            let color = i === this.currentStep ? activeColor : inactiveColor;

            let dot = this.scene.add.rexRoundRectangle(
                i * dotSpacing,
                0,
                dotSize * 2,
                dotSize,
                5,
                color
            );
            dot.setOrigin(0.5);
            this.add(dot);
            this.dots.push(dot);

            // --- 👇 Ajout de l'interaction ---
            dot.setInteractive({ cursor: 'pointer' });
            dot.on('pointerdown', () => {
                this.emit('dotClicked', i); // on émet un event avec l’index
            });
            dot.on('pointerover', () => {
                dot.setAlpha(0.8);
            });
            dot.on('pointerout', () => {
                dot.setAlpha(1);
            });
        }
    }

    updateStep(newStep) {
        this.currentStep = newStep;
        const activeColor = 0xdba94e;
        const inactiveColor = 0xe5e5e5;

        this.dots.forEach((dot, index) => {
            dot.setFillStyle(index === this.currentStep ? activeColor : inactiveColor);
        });
    }
}
